import {
  SCHEDULES_REQUESTED,
  SCHEDULES_SUCCESS,
  SCHEDULES_ERROR
} from "../actions/";

const initialState = {
  loading: false,
  error: false,
  data: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SCHEDULES_REQUESTED: {
      return { ...state, loading: true, error: false };
    }
    case SCHEDULES_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: false };
    case SCHEDULES_ERROR:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
}
